export const ALLOWED_TEXT_THEMES = ['light', 'dark'] as const
export const ALLOWED_BUTTON_THEMES = ['primary', 'amplified'] as const
